'use client'
import React, { FunctionComponent, useEffect, useMemo, useRef } from 'react'
import cn from 'classnames'

import styles from './PageTitle.module.scss'

type PageTitleProps = {
  className?: string
  title: string
}
export const PageTitle: FunctionComponent<PageTitleProps> = React.memo(
  ({ className, title }) => {
    const prepareTitle = useMemo(() => {
      if (!title) return ''
      // Собираем содержимое всех <p>...</p>
      const regex = /<p\b[^>]*>([\s\S]*?)<\/p>/gi
      const parts: string[] = []

      let match: RegExpExecArray | null

      while ((match = regex.exec(title)) !== null) {
        parts.push(match[1])
      }

      if (parts.length > 0) {
        // Вставляем <br> между параграфами (после каждого </p>, кроме последнего)
        return parts
          .map((p, i) => `${p}${i < parts.length - 1 ? '<br />' : ''}`)
          .join('')
      }
      // Если <p> не найден — возвращаем исходную строку
      return title
    }, [])

    return (
      <h1
        className={cn(className, styles.title)}
        dangerouslySetInnerHTML={{ __html: prepareTitle }}
      ></h1>
    )
  }
)
